import { apiPaths } from '@percent/cause-dashboard/services/apiPaths'
import type { AxiosInstance } from 'axios'

export const createChatTargets = {
  grantExpert: 'grant-expert',
  goodstackGrants: 'goodstack-grants',
  weeklyRecommendations: 'weekly-recommendations'
} as const

// Add more targets when needed
export type CreateChatTarget = typeof createChatTargets[keyof typeof createChatTargets]

type AIChatServiceCapabilities = {
  percentClient: AxiosInstance
}

export type ExtractedUtmParameters = {
  utm_source?: string
  utm_medium?: string
  utm_campaign?: string
  utm_term?: string
  utm_content?: string
}

export const UTM_PARAM_KEYS: (keyof ExtractedUtmParameters)[] = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content'
]

export type CreateChatPayload = {
  message?: string
  target?: CreateChatTarget
} & ExtractedUtmParameters

export const aiChatService = ({ percentClient }: AIChatServiceCapabilities) => ({
  createChat: (payload: CreateChatPayload) => percentClient.post(apiPaths.v1CPLinkToken, payload)
})
